// src/services/roleService.js
import api from "../api/api";

// GET semua role
export const getAllRoles = async () => {
  const token = localStorage.getItem("token");
  const res = await api.get("/roles", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data.data;
};

// CREATE role baru
export const createRole = async (payload) => {
  const res = await api.post("/roles", payload);
  return res.data;
};

// UPDATE role berdasarkan ID
export const updateRole = async (id, payload) => {
  const res = await api.put(`/roles/${id}`, payload);
  return res.data;
};

// DELETE role berdasarkan ID
export const deleteRole = async (id) => {
  const res = await api.delete(`/roles/${id}`);
  return res.data;
};
